/*
 * @Descripttion:
 * @version: v1.0
 * @Author: baidongsheng
 * @Date: 2021-12-15 16:04:49
 * @LastEditors: baidongsheng
 * @LastEditTime: 2021-12-22 11:39:05
 */
import StaffSelector from "../../../../../form/src/common/components/form-staff-selector/pc/staff-selector.vue";
import FormRenderer from "../pc-form-renderer.vue";
import H3Textarea from "./h3-textarea.vue";
export default {
    FormRenderer,
    StaffSelector,
    H3Textarea,
};
